import AxiosAPI from '../../../utils/AxiosAPI';

// Get service info by id
export const handleGetServiceInfoOpe = (serviceId) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/services/${serviceId}`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export default null;
